import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { Tooltip } from 'bootstrap';
import { AppSettings } from './../../config/app-settings.js';

function PosTableBooking() {
	const context = useContext(AppSettings);
	const [time] = useState(getTime());
	const [tableData, setTableData] = useState();
	var tooltip = [];
	
	function checkTime(i) {
		if (i < 10) {i = "0" + i};
		return i;
	}
	
	function getTime() {
		var today = new Date();
		var h = today.getHours();
		var m = today.getMinutes();
		var a;
		m = checkTime(m);
		a = (h > 11) ? 'pm' : 'am';
		h = (h > 12) ? h - 12 : h;
	
		setTimeout(() => {
			getTime();
		}, 500);
		return h + ":" + m + a;
	}
	
	function getStatus(time, text) {
		var timeSplit = time.split(':');
		var clock = timeSplit[1].split('00');
		var ampm = clock[1];
		var hour = parseInt(timeSplit[0]);
		var fullHour = (ampm === 'pm' && hour < 12) ? hour + 12 : hour;
		var today = new Date();
		var currentFullHour = today.getHours();
		
		if (fullHour === currentFullHour && text) {
			return 'in-progress';
		} else if (currentFullHour > fullHour && text) {
			return 'completed';
		} else if (currentFullHour < fullHour && text) {
			return 'upcoming';
		}
		return '';
	}
	
	function checkSameHour(time) {
		var today = new Date();
		var currentFullHour = today.getHours();
		var currentAmPm = (currentFullHour > 12) ? 'pm' : 'am';
		var currentHour = (currentFullHour > 12) ? currentFullHour - 12 : currentFullHour;
		var currentHourFinal = (currentHour < 10) ? '0' + currentHour : currentHour;
		var currentTime = currentHourFinal + ':00' + currentAmPm;
		
		if (currentTime === time) {
			return true;
		}
		return false;
	}
	
	function getAvailableTable() {
		var count = 0;
		var today = new Date();
		var h = today.getHours();
		var a;
		a = (h > 11) ? 'pm' : 'am';
		h = (h > 12) ? h - 12 : h;
		
		var currentHour = checkTime(h) + ":00" + a;
		
		if (tableData) {
			for (var i = 0; i < tableData.length; i++) {
				for (var x = 0; x < tableData[i].reservation.length; x++) {
					if (tableData[i].reservation[x].time === currentHour && !tableData[i].reservation[x].text) {
						count++;
					}
				}
			}
		}
		return count;
	}
	
	function checkAvailable(reservation) {
		for (var x = 0; x < reservation.length; x++) {
			var time = reservation[x].time.split(':');
			var hour = parseInt(time[0]);
			var today = new Date();
			var currentHour = today.getHours();
					currentHour = (currentHour > 12) ? currentHour - 12 : currentHour;
					
			if (currentHour === hour && reservation[x].text) {
				return true;
			}
		}
		return false;
	}
	
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentClass('p-0');
		
		var elm = document.querySelectorAll('.pos [data-bs-toggle="tooltip"]');
		for (var i = 0; i < elm.length; i++) {
			var t = new Tooltip(elm[i]);
			tooltip.push(t);
		}
		
		fetch('/quantum-react/assets/data/pos/table-booking.json').then(res => res.json()).then((result) => { setTableData(result); });
		
		return () => {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentClass('');
			
			if (tooltip) {
				for (var i = 0; i < tooltip.length; i++) {
					tooltip[i].dispose();
				}
			}
			const elements = document.querySelectorAll('.tooltip');
			elements.forEach(el => {
				el.remove();
			});
		};
		
		// eslint-disable-next-line
	}, []);
	
	return (
		<>
		<div className="pos pos-vertical pos-with-header" id="pos">
			<div className="pos-container">
				<div className="pos-header">
					<div className="logo">
						<Link to="/">
							<div className="logo-img"><Icon icon="material-symbols-light:food-bank" /></div>
							<div className="logo-text">FOOD BANK</div>
						</Link>
					</div>
					<div className="time" id="time">{ time }</div>
					<div className="nav">
						<div className="nav-item">
							<Link to="/pos/counter-checkout" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Counter Checkout" className="nav-link">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:shopping-cart-checkout-sharp" />
								</div>
							</Link>
						</div>
						<div className="nav-item">
							<Link to="/pos/kitchen-order" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Kitchen Order" className="nav-link">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:order-approve-outline-sharp" />
								</div>
							</Link>
						</div>
						<div className="nav-item">
							<Link to="/pos/table-booking" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Table Booking" className="nav-link active">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:calendar-month-outline-sharp" />
								</div>
							</Link>
						</div>
						<div className="nav-item">
							<Link to="/pos/menu-stock" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Menu Stock" className="nav-link">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:inventory-2-outline-sharp" />
								</div>
							</Link>
						</div>
					</div>
				</div>
					
				<div className="pos-content">
					<div className="pos-content-container p-4 mx-2">
						<div className="d-md-flex align-items-center mb-4">
							<div className="flex-1">
								<div className="h5 mb-1">Available Table ({getAvailableTable()}/20)</div>
								<div className="mb-3 mb-md-0 d-flex fs-10px text-white text-opacity-75">
									<div className="d-flex align-items-center me-3">
										<i className="fa fa-circle fa-fw text-body text-opacity-25 fs-4px me-2"></i> Completed
									</div>
									<div className="d-flex align-items-center me-3">
										<i className="fa fa-circle fa-fw text-warning fs-4px me-2"></i> Upcoming
									</div>
									<div className="d-flex align-items-center me-3">
										<i className="fa fa-circle fa-fw text-theme fs-4px me-2"></i> In-progress
									</div>
								</div>
							</div>
							<div>
								<div className="w-250px input-group">
									<input type="text" className="form-control" name="datepicker" placeholder="yyyy-mm-dd" id="datepickerInput" />
									<label className="input-group-text" htmlFor="datepickerInput">
										<i className="bi bi-calendar"></i>
									</label>
								</div>
							</div>
						</div>
						<div className="row g-3">
							{tableData && tableData.length > 0 ? (tableData.map((table, index) => (
								<div className="col-xl-2 col-lg-3 col-md-4 col-sm-6" key={index}>
									<a href="#/" data-bs-toggle="modal" data-bs-target="#modalPosBooking" className="pos-table-booking">
										<div className="pos-table-booking-container">
											<div className="pos-table-booking-header">
												<div className="d-flex align-items-center">
													<div className="flex-1">
														<div className="title">TABLE</div>
														<div className="no">{table.name}</div>
														<div className="desc">max {table.pax} pax</div>
													</div>
													{!checkAvailable(table.reservation) ? (
														<div className="pe-1 text-success fs-36px">
															<Icon icon="material-symbols-light:check-circle-outline" />
														</div>
													) : (
														<div className="text-body text-opacity-25 fs-36px">
															<Icon icon="material-symbols-light:check-circle-outline" />
														</div>
													)}
												</div>
											</div>
											<div className="pos-table-booking-body">
												{table.reservation.length > 0 ? (table.reservation.map((reservation, index) => (
													<div className={'booking' + ((checkSameHour(reservation.time)) ? ' highlight' : '')} key={index}>
														<div className="time">{reservation.time}</div>
														<div className="info">{(reservation.text) ? reservation.text : '-'}</div>
														<div className={'status '+ getStatus(reservation.time, reservation.text)}>{reservation.text && (<i className="fa fa-circle"></i>)}</div>
													</div>
												))) : (
													<div>
														No records found
													</div>
												)}
											</div>
										</div>
									</a>
								</div>
							))) : (
								<div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
									No records found
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
			
		<div className="modal modal-pos fade" id="modalPosBooking">
			<div className="modal-dialog modal-lg">
				<div className="modal-content border-0">
					<div className="modal-header align-items-center">
						<h5 className="modal-title d-flex align-items-end">
							Table 01 
							<small className="fs-12px ms-2 text-white text-opacity-50">max 4 pax</small>
						</h5>
						<button data-bs-dismiss="modal" className="ms-auto btn-close">&nbsp;</button>
					</div>
					<div className="modal-body">
						<div className="row">
							<div className="col-lg-6">
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">08:00am</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">09:00am</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" defaultValue="Reserved by Sean" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">10:00am</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">11:00am</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">12:00pm</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">01:00pm</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">02:00pm</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">03:00pm</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" />
									</div>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">04:00pm</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">05:00pm</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" defaultValue="Reserved by Irene Wong (4pax)" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">06:00pm</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" defaultValue="Reserved by Irene Wong (4pax)" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">07:00pm</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">08:00pm</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">09:00pm</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" />
									</div>
								</div>
								<div className="form-group mb-2">
									<div className="input-group">
										<div className="input-group-text border-0 w-80px">10:00pm</div>
										<input type="text" className="form-control border-0 bg-black bg-opacity-25" placeholder="" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<button className="btn btn-default w-100px" data-bs-dismiss="modal">CANCEL</button>
						<button type="submit" className="btn btn-success w-100px">BOOK</button>
					</div>
				</div>
			</div>
		</div>
		</>
	)
}

export default PosTableBooking;